export const T = {
  bg:         "var(--bg)",
  card:       "var(--card)",
  card2:      "var(--card2)",
  border:     "var(--border)",
  borderMd:   "var(--border-md)",
  text:       "var(--text)",
  muted:      "var(--muted)",
  muted2:     "var(--muted2)",
  purple:     "var(--purple)",
  purple2:    "var(--purple-2)",
  purpleSoft: "var(--purple-soft)",
  shadowSm:   "var(--shadow-sm)",
  shadow:     "var(--shadow)",
};
